import { useDocument } from "@/composables/useFirestore";
import { useI18n } from "@/composables/useI18n";
import { db } from "@/firebase";
import { APP_VERSION } from "@aircap/common/config";
import type { AppConfig } from "@aircap/common/models";
import { doc } from "firebase/firestore";
import { watch } from "vue";

export function useAppVersion() {
  const { t } = useI18n();
  const versionDocRef = doc<AppConfig>(db, "config", "app");
  const { data: appConfig } = useDocument<AppConfig>(versionDocRef);

  watch(
    appConfig,
    (appConfig) => {
      if (appConfig?.version && appConfig.version > APP_VERSION) {
        if (window.confirm(t("common.newVersionReload"))) {
          window.location.reload();
        }
      }
    },
    { immediate: true },
  );
}
